import { AppBar, TitlePortal } from 'react-admin';
import { ImpersonationIndicator } from '../impersonation/ImpersonationIndicator';
import { IdentityBadge } from './IdentityBadge';
import { RegionSwitcher } from './RegionSwitcher';

/**
 * Custom top bar (step 0.5), built on React Admin's own `<AppBar>` (not a
 * parallel frame): the page title (TitlePortal, which grows and right-aligns
 * the rest), the persistent impersonation indicator (D-impersonation, unmissable
 * while a view-only session is active), the region switcher and the identity
 * badge. Logout stays on RA's default user menu (included by `<AppBar>`),
 * preserving the 0.2 sign-out affordance.
 */
export const AdminAppBar = () => (
  <AppBar>
    <TitlePortal />
    <ImpersonationIndicator />
    <RegionSwitcher />
    <IdentityBadge />
  </AppBar>
);
